import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmploymentContract_Report  {
    _originalTypeClassName = "zERP.BO.EmploymentContract_Report";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmploymentContract_Report.translate = translateService;
}
this.FileHistory = [];
this.NotIncludedSalaries = [];
this.Id = null;
this.DateTime = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateTime:any;
EmploymentContractType:any;
DynamicReport:any;
FileHistory:any;
ActiveFile:any;
SalaryPeriodType:any;
NotIncludedSalaries:any;
static setEmploymentContractType = ($this, value) => {
var oldValue = $this.EmploymentContractType;
$this.EmploymentContractType = value;
if (value != null) {
}
}
static setDynamicReport = ($this, value) => {
var oldValue = $this.DynamicReport;
$this.DynamicReport = value;
if (value != null) {
}
}
static setFileHistory = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileHistory == null) $this.FileHistory = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileHistory.length > 0) {
                    Domain.EmploymentContract_Report.removeFileHistory($this, $this.FileHistory[0]);
                }

                Domain.EmploymentContract_Report.addManyFileHistory($this, copyItems);
            }
static addManyFileHistory = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContract_Report.addFileHistory($this, items[i]);
                }
            }
static addFileHistory = ($this, item) => {
                if ($this.FileHistory == null) $this.FileHistory = [];
                if (item == null || $this.FileHistory.indexOf(item) > -1) return;
                $this.FileHistory.push(item);
}
static addRangeFileHistory = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContract_Report.addFileHistory($this, item));
            }
static removeFileHistory = ($this, item) => {
                if ($this == null || $this.FileHistory == null || $this.FileHistory.indexOf(item) === -1) return;
                var _index = $this.FileHistory.indexOf(item);
                $this.FileHistory.splice(_index, 1);
}
static clearFileHistory = ($this) => { $this.FileHistory = null; }
static setActiveFile = ($this, value) => {
var oldValue = $this.ActiveFile;
$this.ActiveFile = value;
if (value != null) {
}
}
static setSalaryPeriodType = ($this, value) => {
var oldValue = $this.SalaryPeriodType;
$this.SalaryPeriodType = value;
if (value != null) {
}
}
static setNotIncludedSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.NotIncludedSalaries == null) $this.NotIncludedSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.NotIncludedSalaries.length > 0) {
                    Domain.EmploymentContract_Report.removeNotIncludedSalaries($this, $this.NotIncludedSalaries[0]);
                }

                Domain.EmploymentContract_Report.addManyNotIncludedSalaries($this, copyItems);
            }
static addManyNotIncludedSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContract_Report.addNotIncludedSalaries($this, items[i]);
                }
            }
static addNotIncludedSalaries = ($this, item) => {
                if ($this.NotIncludedSalaries == null) $this.NotIncludedSalaries = [];
                if (item == null || $this.NotIncludedSalaries.indexOf(item) > -1) return;
                $this.NotIncludedSalaries.push(item);
}
static addRangeNotIncludedSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContract_Report.addNotIncludedSalaries($this, item));
            }
static removeNotIncludedSalaries = ($this, item) => {
                if ($this == null || $this.NotIncludedSalaries == null || $this.NotIncludedSalaries.indexOf(item) === -1) return;
                var _index = $this.NotIncludedSalaries.indexOf(item);
                $this.NotIncludedSalaries.splice(_index, 1);
}
static clearNotIncludedSalaries = ($this) => { $this.NotIncludedSalaries = null; }

static UpdateHistory($this: any, activeFile: any): any{if (activeFile == null) {throw Error(this.translate.instant('DynamicReportBO_RES_CUSTOM_FILE_DATA_NOT_FOUND'));}
let item = $this?.FileHistory?.linq?.where((i) => (new Date(i?.FileData?.UploadDateTime).getTime()) == (new Date(activeFile?.FileData?.UploadDateTime).getTime()))?.firstOrDefault(null);
if (((new Date(activeFile?.FileData?.UploadDateTime).getTime()) != (new Date(item?.FileData?.UploadDateTime).getTime()))) {$this?.FileHistory?.add(activeFile);}
}
static UploadTemplate($this: any, fileData: any,description: any): any{if (fileData == null) {throw Error(this.translate.instant('DynamicReportBO_RES_CUSTOM_FILE_DATA_NOT_FOUND'));}
let dynamicReportFileInfo = new Domain.DynamicReportFileInfo();
dynamicReportFileInfo.UploadedAt = moment().toDate();
Domain.DynamicReportFileInfo.setFileData(dynamicReportFileInfo, fileData);
dynamicReportFileInfo.Description = description;
Domain.EmploymentContract_Report.setActiveFile($this, dynamicReportFileInfo);
return dynamicReportFileInfo;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}